import type { IPost } from "../../../../types/models/post.models.types";
import { useGetHttp } from "../../http.hook";

 interface IResponse {
  post: IPost;
}

export function useGetPostsByIdAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/posts/:id",
  });
}
